<template>
  <div>
    <b-row
      ><b-col md="8">
        <button size="sm" @click="backButton">
          <i
            class="fa fa-arrow-left"
            aria-hidden="false"
            style="
              font-size: 18px;
              color: rgb(38, 38, 38);
              position: relative;
              top: 30px;
            "
          ></i>
        </button>
        <h3 class="ml-3">Business Plan Details</h3>
      </b-col>
      <b-col md="4">
        <div class="margin">
          <b-button
            variant="primary"
            class="profile-btn"
            @click="
              $router.push({
                name: 'Edit Business Plan',
                params: {
                  id: planDetails._id,
                },
              })
            "
            style="margin-right: 10px"
            >Edit Business Plan
          </b-button>
          <b-button
            variant="danger"
            class="delete-btn ml-1"
            @click="deleteBusinessPlan"
            >Delete
          </b-button>
        </div></b-col
      >
    </b-row>
    <b-card>
      <b-row class="mx-1">
        <b-col md="2">
          <b-col>
            <v-avatar size="75">
              <img :src="planDetails.image" alt />
            </v-avatar>
          </b-col>
          <b-col
            class="price"
            v-if="
              planDetails &&
              planDetails.subscriptions &&
              planDetails.subscriptions[planDetails.subscriptions.length - 1]
                .pricing
            "
          >
            <span class="amount">Price ₹ {{ totalPrice }}</span>
          </b-col>
        </b-col>

        <b-col md="8">
          <div>
            <h5 class="mt-1 font1">
              Plan Name:
              <span class="mt-1 font2">
                {{ planDetails.plan_name || "" }}
              </span>
            </h5>
          </div>
          <div class="mt-4">
            <h5 class="mt-1 font1">
              Description:
              <span class="mt-1 mb-4 font2">
                {{ planDetails.description }}
              </span>
            </h5>
          </div>
        </b-col>
      </b-row>
    </b-card>
    <b-row
      ><b-col md="7">
        <h3 class="ml-2">Added Subscription</h3>
      </b-col>
    </b-row>
    <b-table
      :hover="true"
      :items="features1"
      :striped="striped"
      :fields="Column1"
      :dark="false"
      :bordered="bordered"
      :small="small"
      :fixed="fixed"
      responsive="sm"
      id="my-table"
      :current-page="currentPage"
      :per-page="perPage"
      thead-class="header"
      class="mt-3"
      show-empty
      :no-border-collapse="true"
      @filtered="onFilter"
    ></b-table>

    <b-row
      ><b-col md="7">
        <h3 class="ml-2">Add Feature</h3>
      </b-col>
    </b-row>
    <b-table
      :hover="true"
      :items="features"
      :striped="striped"
      :fields="Column"
      :dark="false"
      :bordered="bordered"
      :small="small"
      :fixed="fixed"
      responsive="sm"
      id="my-table"
      :current-page="currentPage"
      :per-page="perPage"
      thead-class="header"
      class="mt-3"
      show-empty
      :no-border-collapse="true"
      @filtered="onFilter"
    ></b-table>
  </div>
</template>
<script>
import ebSelect from "@/components/FormElements/Select.vue";
import { mapGetters, mapActions } from "vuex";
export default {
  components: {
    ebSelect,
  },
  data() {
    return {
      text: "",
      Column1: [
        { label: "PlanName", key: "planName" },
        { label: "description", key: "planDescription" },
        { label: "Plan Price", key: "pricing" },
      ],
      Column: [
        { label: "featureName", key: "name" },
        { label: "description", key: "description", class: "textAlignment" },
        {
          label: "permissionAdded",
          key: "permission",
          formatter: "NoOfPermissions",
        },
      ],
      features: [],
      features1: [],
      striped: false,
      bordered: true,
      small: false,
      fixed: false,
      currentPage: 1,
      perPage: 9,
      filterCount: 0,
      planDetails: "",
    };
  },
  computed: {
    ...mapGetters({
      getFeatureList: "businessPlan/GetfeatureList",
      businessPlanList: "businessPlan/GetBusinessPlanList",
    }),

    getSubscription() {
      const data = this.getSubscriptionList;
      let newList = [];
      data.map((each) => {
        let arrayObj = {
          id: each._id,
          planName: each.planName,
          planDescription: each.planDescription,
          pricing: each.pricing.price,
        };
        newList.push(arrayObj);
      });
      return newList;
    },
    totalPrice() {
      let total = 0;
      total = this.features1.reduce((acc, a) => {
        return acc + a.pricing;
      }, 0);
      return total || 0;
    },
  },
  methods: {
    ...mapActions({
      fetchFeatureList: "businessPlan/featureList",
      fetchBusinessPlanList: "businessPlan/businessPlanList",
      deletePlan: "businessPlan/deleteBusinessPlan",
    }),
    onFilter(list) {
      this.filterCount = list.length;
      this.currentPage = 1;
    },
    backButton() {
      this.$router.push({ path: "/businessPlan" });
    },
    async deleteBusinessPlan() {
      await this.$swal({
        title: "Are you sure?",
        text: "You can't revert this action!!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
      }).then((result) => {
        if (result.value) {
          const payload = { id: this.$route.params.id };
          this.deletePlan(payload).then((result) => {
            this.$toasted.success("Business Plan Deleted Successfully");
            this.fetchBusinessPlanList().catch((error) => {
              this.$toasted.error(error.message);
            });
          });
          this.$router.push("/businessPlan");
        }
      });
    },

    NoOfPermissions(value) {
      return value.length;
    },
    async fetchBusinessPlanDetails() {
      const data = await this.$store.dispatch(
        "businessPlan/businessPlanDetails",
        {
          id: this.$route.params.id,
        }
      );
      this.planDetails = data?.data?.response;
      this.features = data?.data?.response.features;
      this.features1 = data?.data?.response.subscriptions;
      return this.planDetails;
    },
    async fetchFeatureDetails() {
      await this.$store.dispatch("businessPlan/featureListDetail", {
        id: this.$route.params.id,
      });
    },
  },
  mounted() {
    this.fetchBusinessPlanDetails();
    this.fetchFeatureDetails();
    this.fetchFeatureList();
  },
};
</script>
<style>
.refresh-button {
  position: absolute;
  top: 12px;
  font-size: large;
  z-index: 1;
  right: 15px;
  width: 42px;
  height: 35px;
  padding: 0px;
}

.amount {
  font-weight: 600;
}
.price {
  font-size: 14px;
  color: black;
  font-weight: 600px;
  margin-top: 10px;
}
.profile-btn {
  background-color: var(--primary);
  height: 38px;
  width: 148px;
}
.delete-btn {
  height: 38px;
  width: 98px;
}
.delete-btn:hover {
  background-color: #ff3a3a;
}
.feature-select {
  margin-left: 50px;
}
.font1 {
  font-size: 15px;
}
.font2 {
  font-weight: lighter;
  font-size: 14px;
  line-height: 1.5rem;
}
.margin {
  margin-left: 55px;
}
td.textAlignment {
  text-align: justify !important;
  white-space: pre-wrap;
}
</style>
